module.exports = __webpack_public_path__ + "img/tab_customer-w.7d3c7527.svg";